<template>
  <select id="sortingButtons" class="sorting-buttons q-form-select q-rounded-3 q-shadow-sm q-border-0" aria-label="Sorting select options"
          @change="sortingStore.updateSorting($event)">
    <option v-for="sort in sortingStore.sort" :name="sort.id" :key="sort.id" :selected="sort.id === selectedSort">
      {{ sort.label }}
    </option>
  </select>
</template>
<script setup lang="ts">
import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {onMounted, toRefs} from "vue";

const sortingStore = useSortingStore();
const {selectedSort} = toRefs(sortingStore)

onMounted(() => {
  sortingStore.fetchSortingOptions()
  selectedSort.value = sortingStore.getSelectedSortFromUrl()
})
</script>
<style>
.sorting-buttons {
  cursor: pointer;
}

.q-form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: none !important;
}
</style>